<template>
  <n-modal-provider>
    <n-message-provider>
      <n-dialog-provider>
        <RouterView />
      </n-dialog-provider>
    </n-message-provider>
  </n-modal-provider>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { getRefreshToken, logout } from '@/utils/auth';
import { useLocalStorageStore } from '@/store/localStorageStore';
import { useRouter } from 'vue-router';

const router = useRouter();

let timer: NodeJS.Timeout | undefined;

const localStorageStore = useLocalStorageStore();
localStorageStore.init();

onMounted(async () => {
  timer = setInterval(async () => {
    const serverToken = await getRefreshToken();
    const localToken = localStorageStore.items.refresh_token;
    if (serverToken) {
      if (!localToken) {
        localStorageStore.setItem('refresh_token', serverToken);
      } else if (serverToken !== localToken) {
        await logout();
        localStorageStore.clear();
        router.push({
          path: '/login',
          query: {
            thereLogin: 'true'
          }
        });
      }
    }
  }, 30000);
});

onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});
</script>

<style scoped>
</style>
<style>

</style>